import type { ValidationErrors } from 'sonata-react-components';
import type { GeoDataAndScreensInteface } from 'sonata-static-storage/lib/schemas/screen/screen.schema';
import type { Zone } from 'sonata-static-storage/lib/schemas/zone/zone.schema';

export function checkMainSettingsAreConfigured(errors?: ValidationErrors): boolean {
  if (errors?.countries) {
    return false;
  }
  if (errors?.ioNumber) {
    return false;
  }
  if (errors?.name) {
    return false;
  }
  if (errors?.flights) {
    return false;
  }
  if (errors?.scheduleParting) {
    return false;
  }
  if (errors?.goals) {
    return false;
  }
  if (errors?.beginDate || errors?.endDate) {
    return false;
  }
  return true;
}

export function checkLocationsOrScreensAreConfigured(items: Zone[] | GeoDataAndScreensInteface[] | null): boolean {
  if (!items) {
    return false;
  }
  // A smart location doesn't count as configured — at least one non-smart location (or any screen) is required.
  // Treated as "no locations" on purpose: no dedicated smart error, reuses the locations-not-configured behavior.
  // Mirrors the reporting "real activation area" filter in LocationsLayer: smart, attribution-torus and
  // retargeting-only zones are excluded, as are deleted zones and deleted screens.
  return items.some(item => {
    if ('smart' in item) {
      return (
        !item.deleted &&
        !item.smart &&
        item.type !== 'attributionTorus' &&
        !(item.retargetingCandidate && item.retargetingType === 'only')
      );
    }
    return !item.deleted;
  });
}

export function checkContextTargetingAreConfigured(errors?: ValidationErrors): boolean {
  return !errors?.targeting;
}

export function checkAdCreativesAreConfigured(errors?: ValidationErrors): boolean {
  return !errors?.ads;
}
